// Curated Google Fonts for per-client portal branding. Mirrors the backend
// catalog in services/brand_fonts.py (family names must match exactly).

export const PORTAL_FONTS = [
    { family: "Default", stack: null, google: null },
    { family: "Bebas Neue", stack: "'Bebas Neue', system-ui, sans-serif", google: "Bebas+Neue" },
    { family: "Playfair Display", stack: "'Playfair Display', Georgia, serif", google: "Playfair+Display:ital,wght@0,400;0,600;0,700;1,400" },
    { family: "Montserrat", stack: "'Montserrat', system-ui, sans-serif", google: "Montserrat:wght@400;500;600;700" },
    { family: "Poppins", stack: "'Poppins', system-ui, sans-serif", google: "Poppins:wght@400;500;600;700" },
    { family: "Oswald", stack: "'Oswald', system-ui, sans-serif", google: "Oswald:wght@400;500;600;700" },
    { family: "Lora", stack: "'Lora', Georgia, serif", google: "Lora:wght@400;500;600;700" },
];

const byFamily = (f) => PORTAL_FONTS.find((x) => x.family === f);

// CSS font-family stack for a family, or null for Default/unknown.
export function fontStack(family) {
    return byFamily(family)?.stack || null;
}

// Inject the Google Fonts <link> once for a chosen family.
export function loadGoogleFont(family) {
    const f = byFamily(family);
    if (!f || !f.google || typeof document === "undefined") return;
    const id = `gf-${f.family.replace(/\s+/g, "-")}`;
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${f.google}&display=swap`;
    document.head.appendChild(link);
}
